import finishFormula from '@/core/components/finishFormula'
import finishPrice from '@/core/components/finishPrice'
import createdAt from '@/core/components/createdAt'
import store from '@/store'
// import vue from 'vue'
// const that = vue.prototype

export default {
  // 成品
  className: 'finishProduct',
  // fields: [
  //   {
  //     name: 'name',
  //     validators: [
  //       (val) => val ? null : '型号不可为空'
  //     ]
  //   },
  //   {
  //     name: 'content',
  //     validators: [
  //       (val) => val ? null : '含量不可为空'
  //     ]
  //   },
  //   {
  //     name: 'price',
  //     view: {
  //       component: finishPrice
  //     },
  //     disabled: true
  //   },
  //   'describe'
  // ],
  mixin: {
    actionWidth: 120,
    fields: [
      {
        name: 'name',
        validators: [
          (val) => val ? null : '型号不可为空'
        ],
      },
      {
        name: 'content',
        validators: [
          (val) => val ? null : '含量不可为空'
        ]
      },
      {
        name: 'price',
        view: {
          component: finishPrice
        },
        disabled: true
      },
      {
        name: 'createdAt',
        width: 120,
        view: {
          component: createdAt
        },
        disabled: true
      },
      // 'updatedAt',
      'describe',
    ],
    search: [],
  },
  hooks: {
    beforeFetch ({ where }) {
      where.isBatching = { $ne: true }
      if (store.state.user.allShopManagements === 'Yes') {
      } else {
        where.workShop = {
          $in: store.state.user.shopManagements,
          $exists: true
        }
      }
    }
  },
  action:
  {
    formula: store.state.user && store.state.user.authority.finishProduct.formula
      ? {
        type: 'row',
        text: '修改配方',
        component: finishFormula
      } : false,
    edit: store.state.user && store.state.user.authority.finishProduct.edit ? {} : false
  }
}
